import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-linked-consent',
  templateUrl: './account-linked-consent.component.html',
  styleUrls: ['./account-linked-consent.component.scss']
})

/**
 * Component is being used in the dashboard to show consents. It is programmatically used in the accountlist component
 */
export class AccountLinkedConsentComponent implements OnInit {

  consentStatus: String;
  isConsentRevoked: boolean;
  isConsentPaused: boolean;

  @Input()
  consentArtefact;
  
  @Output() consentRevokeId = new EventEmitter();
  @Output() consentUpdateEvent = new EventEmitter();

  constructor(
    private http: HttpService,
    private route: Router
  ) { }

  ngOnInit() {
    this.prepareData();
  }

  prepareData() {
    this.consentStatus = this.consentArtefact.status;
    this.isConsentRevoked = this.consentStatus == 'REVOKED' ? true : false;
    this.isConsentPaused = this.consentStatus == 'PAUSED' ? true : false;

    this.consentArtefact.createTime  = new Date(this.consentArtefact.createTime);
    this.consentArtefact.expireTime  = new Date(this.consentArtefact.expireTime);
    this.consentArtefact.duration    = Math.floor((this.consentArtefact.expireTime-this.consentArtefact.createTime)/(1000 * 3600 * 24*30));
    if(this.consentArtefact.duration>0){
      this.consentArtefact.period=this.consentArtefact.duration+" Month(s)"
    }else{
      this.consentArtefact.duration    = Math.ceil((this.consentArtefact.expireTime-this.consentArtefact.createTime)/(1000 * 3600 * 24));
      this.consentArtefact.period=this.consentArtefact.duration+ " Day(s)"
    }
  }

  consentRevoke(consentId) {
    this.consentRevokeId.emit(consentId);
  }

  consentUpdate(consentId) {
    let params = {
      status : this.consentArtefact.status == 'PAUSED' ? "ACTIVE" : "PAUSED",
      consentId : consentId
    }
    this.consentUpdateEvent.emit(params);
  }

  consentTimeline(consentId) {
    this.route.navigate(['/consent-timeline']);
  }
}
